"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils = require("./tree-utils");
var Basket = /** @class */ (function () {
    function Basket(core) {
        this.tree = core.tree;
        this.attributions = core.attributions;
        this.remaining = core.baskets;
    }
    Basket.deserialize = function (serialized) {
        var core = JSON.parse(serialized);
        return new Basket(core);
    };
    Basket.prototype.serialize = function () {
        return JSON.stringify({ tree: this.tree, attributions: this.attributions, baskets: this.remaining });
    };
    Basket.prototype.getAttributions = function (index) {
        return this.attributions[index];
    };
    Basket.prototype.relativeAt = function (branch, relativeBranch) {
        return this.tree[utils.relativeAt(this.tree, branch, relativeBranch)];
    };
    Basket.prototype.withExpansion = function (expansion) {
        var newCore = utils.expandTree(this.tree, expansion.tree);
        var newAttributions = __assign({}, this.attributions, expansion.attributions);
        var newRemaining = __assign({}, this.remaining);
        delete (newRemaining[expansion.id]);
        return new Basket({ tree: newCore, attributions: newAttributions, baskets: newRemaining });
    };
    Basket.prototype.branchIsTerminal = function (branch) {
        return !!this.tree[branch];
    };
    Basket.prototype.hasExpansion = function (branch) {
        var expansion = null;
        while (branch > 0) {
            if (this.remaining[branch]) {
                expansion = this.remaining[branch];
            }
            branch = branch >> 1;
        }
        return expansion;
    };
    return Basket;
}());
exports.Basket = Basket;
